// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__9erx0","divider":"Divider_divider__sSbUM"};